import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum GroupTypeEnum {
    Scheduling = 1,
    Clinical = 2,
    Billing = 3,
    Other = 4
}

export enum GroupTypeNameEnum {
    "Scheduling" = GroupTypeEnum.Scheduling,
    "Clinical" = GroupTypeEnum.Clinical,
    "Billing" = GroupTypeEnum.Billing,
    "Other" = GroupTypeEnum.Other
}

export class GroupTypeEnumClass extends EnumWithDescription<GroupTypeEnum> {
    public readonly enum = GroupTypeEnum;
    public readonly enumName: string = "GroupType";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<GroupTypeEnum>> = new Map([
        [
            "Scheduling",
            {
                value: GroupTypeEnum.Scheduling,
                name: "Scheduling"
            }
        ],
        [
            "Clinical",
            {
                value: GroupTypeEnum.Clinical,
                name: "Clinical"
            }
        ],
        [
            "Billing",
            {
                value: GroupTypeEnum.Billing,
                name: "Billing"
            }
        ],
        [
            "Other",
            {
                value: GroupTypeEnum.Other,
                name: "Other"
            }
        ]
    ]);
}

export const GroupType = new GroupTypeEnumClass();
